import React from 'react';
import { Helmet } from 'react-helmet-async';

import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import WhoWeAre from '../components/WhoWeAre';
import WhatWeDo from '../components/WhatWeDo';
import Certificates from '../components/Certificates';
import Careers from '../components/Careers';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Blog from '../components/Blog';
import FloatingSocials from "../components/FloatingSocials";
import Promoted from "../components/Promoted";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Brion Enterprises | Financial Markets Firm in Mumbai</title>

        <meta
          name="description"
          content="Brion Enterprises LLP is a Mumbai-based financial markets firm and authorised person of a SEBI-registered broker, serving HNI and UHNI clients with technology-driven investment strategies."
        />

        <meta
          name="keywords"
          content="wealth education Mumbai, financial advisory, HNI investment, UHNI services, SEBI authorised person, capital markets firm, Brion Enterprises"
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Navigation />
        <HeroSection />
        <WhoWeAre />
        <WhatWeDo />
        <Certificates />
        <Blog />
        <Careers />
        <Contact />
        <Promoted />
        <Footer />
        <FloatingSocials />
      </div>
    </>
  );
}
